import qs from 'query-string';

export default function queryParser(string){
    return qs.parse(string, { ignoreQueryPrefix: true });
}